import { Stack, Typography } from '@mui/material';
import { SelectFilter } from '@retail/components';
import { useProductsTFunction } from '@retail/products/i18n';
import { ProductGroup } from '@retail/products/types';

interface Props {
  productGroups: ProductGroup[];
  selectedProductGroup: string | null;
  selectProductGroup: (productGroupNr: string | null) => void;
}

export function SelectProductGroup({
  productGroups,
  selectedProductGroup,
  selectProductGroup,
}: Props) {
  const t = useProductsTFunction();

  return (
    <SelectFilter
      label={t('products.search.productGroup.label')}
      placeholder={t('products.search.productGroup.searchInProductgroup')}
      options={productGroups}
      value={
        productGroups.find(({ groupNumber }) => groupNumber === selectedProductGroup) ?? null
      }
      onChange={(productGroup) => selectProductGroup(productGroup?.groupNumber ?? null)}
      dividers
      getOptionKey={({ groupNumber }) => groupNumber}
      getOptionLabel={({ name, groupNumber }) => `${groupNumber} ${name}`}
      renderOptionContent={({ name, groupNumber }) => (
        <Stack flexDirection="row" gap={1}>
          <Typography variant="body2">{groupNumber}</Typography>
          <Typography variant="body2">{name}</Typography>
        </Stack>
      )}
    />
  );
}
